import React from 'react';
import PropTypes from 'prop-types';

import { Checkbox } from '@ontruck/orc';

const ExtraCheckbox = (props) => {
  return <Checkbox size="M" girded {...props} />;
};

ExtraCheckbox.propTypes = {
  label: PropTypes.string.isRequired,
};

export default ExtraCheckbox;
